import { createApp } from 'vue';
import './theme.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/rail.css';
import './styles/surface.css';
import App from './App.vue';

// Font Awesome — mirroring the frontend's main.ts registration so duplicated
// components render identically.
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import {
  faShieldAlt,
  faSkull,
  faRunning,
  faStar,
  faDiamond,
  faCheck,
  faEye,
  faGear,
  faCircle,
  faFlag,
  faCrown,
  faLink,
  faFistRaised,
  faGhost,
  faCheckCircle,
  faMeteor,
  faStop,
  faTree,
  faWandSparkles,
  faHouseChimneyCrack,
  faFire,
  faBiohazard,
  faMoon,
  faDrumstickBite,
  faShieldHalved,
  faShield,
  faSitemap,
  faLock,
  faIndustry,
  faMusic,
  faMountain,
  faWater,
  faWind,
  faHandSparkles,
  // Editor UI chrome icons
  faRotateLeft,
  faRotateRight,
  faArrowsRotate,
  faShapes,
  faPencil,
  faFilePen,
  faTrash,
  faXmark,
  // Tool picker icons
  faArrowPointer,
  faVectorSquare,
  faPenRuler,
  faAlignLeft,
  faBullseye,
  faTag,
  faArrowRightLong,
  faGripVertical,
  // Mirror picker icons
  faBan,
  faArrowsLeftRight,
  faArrowsUpDown,
  faUpDownLeftRight,
  faPlus,
  faChevronDown,
  // Battlepack bar icons
  faBoxArchive,
  faFolderOpen,
  faFileExport,
  faEllipsis,
  faCopy,
  faChessKnight,
  faBookBookmark,
  faCircleQuestion,
  faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faShieldAlt,
  faSkull,
  faRunning,
  faStar,
  faDiamond,
  faCheck,
  faEye,
  faGear,
  faCircle,
  faFlag,
  faCrown,
  faLink,
  faFistRaised,
  faGhost,
  faCheckCircle,
  faMeteor,
  faStop,
  faTree,
  faWandSparkles,
  faHouseChimneyCrack,
  faFire,
  faBiohazard,
  faMoon,
  faDrumstickBite,
  faShieldHalved,
  faShield,
  faSitemap,
  faLock,
  faIndustry,
  faMusic,
  faMountain,
  faWater,
  faWind,
  faHandSparkles,
  faRotateLeft,
  faRotateRight,
  faArrowsRotate,
  faShapes,
  faPencil,
  faFilePen,
  faTrash,
  faXmark,
  faArrowPointer,
  faVectorSquare,
  faPenRuler,
  faAlignLeft,
  faBullseye,
  faTag,
  faArrowRightLong,
  faGripVertical,
  faBan,
  faArrowsLeftRight,
  faArrowsUpDown,
  faUpDownLeftRight,
  faPlus,
  faChevronDown,
  faBoxArchive,
  faFolderOpen,
  faFileExport,
  faEllipsis,
  faCopy,
  faChessKnight,
  faBookBookmark,
  faCircleQuestion,
  faRightFromBracket,
  faDiscord,
);

const app = createApp(App);
app.component('FontAwesomeIcon', FontAwesomeIcon);
app.mount('#app');
